import { ReactNode } from "react";

/**
 * 企微 H5 专用布局：无侧边栏，移动端居中，适配安全区。
 */
export function WeComLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-muted flex flex-col">
      <div className="flex-1 flex flex-col w-full max-w-[480px] mx-auto bg-card min-h-screen">
        {children}
      </div>
    </div>
  );
}
